export const spacing = {
  space: {
    15: "3.75rem",
  },
}
